import { ApiFlowShopSimple, ApiUser } from 'src/interfaces/interfaces.generated';

export const numAffectedShopsWS = (shops: ApiFlowShopSimple[], user: ApiUser): number =>
  shops.filter((shop) => user?.userName && shop?.users?.includes(user.userName)).length;
